import React from 'react';

import './Title.css';

const Title = props => {
    return (
        <div className="title-main">
            <div className="title-container">
                <div className="title-text">{props.title}</div>
                    <div className="subtitle-text">{props.subtitle}</div>
            </div>
        </div>
    )
};

export default Title
